import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-menu-link',
  templateUrl: './menu-link.component.html',
  styleUrls: ['./menu-link.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent
  ]
})
export class MenuLinkDsComponent {

  @Input() icon: Icon;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hasNotification = false;
  @Input() isDisabled = false;
  @Input() isStrong = false;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly fontSize = TypographyFontSize;
  public readonly fontFamily = TypographyFontFamily;
  public readonly fontColor = TypographyColor;

  public readonly icons = Icon;
  public readonly iconFillColor = IconFillColor;

  constructor() { }

  public clickTrigger(): void {
    if (!this.isDisabled) {
      this.clickEvent.emit();
    }
  }
}
